module.exports = __webpack_public_path__ + "1b8f30427c98789e708e2c0c6aef3459.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-72@2x.png
// module id = 534
// module chunks = 0